<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    forecaster: {
      type: Object,
      default: null
    },
  });

  const forecasterBioUrl = computed(() => props.forecaster ? `https://tempest.earth/forecasters/${props.forecaster.bio_slug}/` : null);

</script>

<template>
  <p v-if="forecasterBioUrl" class="jwx-pro-forecast__credits jwx-font-size-sm">Forecast and tables above prepared by meteorologist <a :href="forecasterBioUrl" target="_blank" class="jwx-pro-forecast__credits-author">{{ props.proForecast.forecaster }}</a></p>
  <p v-else class="jwx-pro-forecast__credits jwx-font-size-sm">Forecast and tables above prepared by meteorologist <span class="jwx-pro-forecast__credits-author">{{ props.proForecast.forecaster }}</span></p>
</template>